import type { ReactNode } from "react";

type ShowProps = {
  when: boolean;
  children: ReactNode;
  fallback?: ReactNode;
};

export function Show({ when, children, fallback = null }: ShowProps) {
  if (when) return <>{children}</>;
  return <>{fallback}</>;
}
